import React from 'react';

import CabinIcon from '../../../icons/Cabin';
import CheckinIcon from '../../../icons/CheckIn';

import { CarrierLogo, SpinnerLoader } from '../common-elements.styles';

import * as S from './bagCancelRules.styles';

const BaggageDetails = ({ baggageData, meta }) => {
  if (!baggageData || !Object.keys(baggageData).length) {
    return (
      <div className="padT20">
        <SpinnerLoader />
      </div>
    );
  }
  // if (!baggageData) {
  //   return null;
  // }
  const baggageOrder = meta?.bo || [];
  let sectors = Object.keys(baggageData);
  if (baggageOrder && baggageOrder.length) {
    sectors = baggageOrder;
  }

  const getRowData = (data, rowType = '') => {
    let prop = rowType;
    if (rowType === 'header') {
      prop = 'name';
    }
    const spanEle = Object.keys(data).map((key, index) => {
      return (
        <S.Cscell header={rowType === 'header'} key={key}>
          {rowType === 'header' ? (
            <span className="dF alignItemsCenter">
              {(key === 'cb' && (
                <CheckinIcon width="1.6rem" height="1.6rem" className="marginL5" />
              )) ||
                null}
              {(key === 'hb' && (
                <CabinIcon width="1.6rem" height="1.6rem" className="marginL5" />
              )) ||
                null}
              {data[key][prop]}
            </span>
          ) : (
            <>{data[key][prop]}</>
          )}
        </S.Cscell>
      );
    });
    return spanEle;
  };

  return (
    <>
      {sectors &&
        sectors.length > 0 &&
        sectors.map(key => {
          const sector = baggageData[key];
          const { carrierid, flightno } = sector;
          return (
            <S.Baggage key={`${carrierid}${flightno}`}>
              <div className="marginB15 dF alignItemsCenter">
                <CarrierLogo
                  src={`https://imgak.goibibo.com/flights-gi-assets/images/v2/app-img/${carrierid}.webp`}
                  alt="Flights"
                />
                <span className="font16 f500">{key}</span>
                <span className="font14 marginL10">({`${carrierid} ${flightno}`})</span>
              </div>

              <S.Cstable className="font14">
                <S.Csrow>{getRowData(sector.terms[0], 'header')}</S.Csrow>
                <S.Csrow>{getRowData(sector.terms[0], 'value')}</S.Csrow>
                {sector.terms[1]?.bt?.value && (
                  <S.Csrow>{getRowData(sector.terms[1], 'value')}</S.Csrow>
                )}
                {sector.terms[2]?.bt?.value && (
                  <S.Csrow>{getRowData(sector.terms[2], 'value')}</S.Csrow>
                )}
              </S.Cstable>

              <p className="padT10">{sector?.tnc}</p>
            </S.Baggage>
          );
        })}
    </>
  );
};

export default BaggageDetails;
